import { useMutation } from "@tanstack/react-query";
import { apiPost } from "../lib/api";

/**
 * Ask for a reset link.
 *
 * The server answers 204 for every well-formed request, including an address
 * nobody has: anything else would turn the route into a list of who holds an
 * account. So there is nothing to branch on here, and the page must NOT try
 * to tell the caller whether the address was found.
 */
export function useRequestPasswordReset() {
  return useMutation({
    mutationFn: (email: string) =>
      apiPost<void>("/auth/forgot-password", { email }),
    // Rendered on the page beside the form, not as a toast.
    meta: { suppressErrorToast: true },
  });
}

/** Redeem a reset link. */
export function useResetPassword() {
  return useMutation({
    mutationFn: (vars: { token: string; password: string }) =>
      apiPost<void>("/auth/reset-password", vars),
    meta: { suppressErrorToast: true },
  });
}
